var map = {
	"./ball_cont_bad.svg": "bfef",
	"./ball_cont_good.svg": "8fc8",
	"./eye_sight_bad.svg": "77a0",
	"./eye_sight_good.svg": "a82e",
	"./health_bad.svg": "9038",
	"./health_good.svg": "c0be",
	"./myposition_am.svg": "d2c9",
	"./myposition_cb.svg": "0b85",
	"./myposition_cf.svg": "19e9",
	"./myposition_cm.svg": "21b3",
	"./myposition_dm.svg": "c584",
	"./myposition_fb.svg": "548b",
	"./myposition_gk.svg": "fb12",
	"./myposition_ss.svg": "7614",
	"./myposition_wb.svg": "9f0b",
	"./myposition_wf.svg": "fe7b",
	"./myposition_wm.svg": "6b3c",
	"./pass_bad.svg": "dfd1",
	"./pass_good.svg": "c0d6",
	"./speed_bad.svg": "7434",
	"./speed_good.svg": "73cf",
	"./경기흐름.svg": "2191",
	"./공제어감각.svg": "9a58",
	"./모험심.svg": "8ff6",
	"./배려심.svg": "8a65",
	"./서브2_공제어감각.svg": "9ecc",
	"./서브2_시야.svg": "ba20",
	"./서브2_체력.svg": "7fc3",
	"./서브2_키.svg": "ad4f",
	"./서브2_패스킥슛.svg": "20d0",
	"./서브3_공제어감각.svg": "89a3",
	"./서브3_시야.svg": "8bf3",
	"./서브3_패스킥슛.svg": "ab37",
	"./서브4_공제어감각.svg": "838a",
	"./서브4_시야.svg": "5d65",
	"./서브4_패스킥슛.svg": "56a9",
	"./서브5_시야.svg": "27b0",
	"./서브5_패스킥슛.svg": "5d97",
	"./서브6_패스킥슛.svg": "68aa",
	"./서브_공제어감각.svg": "18ed",
	"./서브_모험심.svg": "7b7a0",
	"./서브_배려심.svg": "bf76",
	"./서브_시야.svg": "8624",
	"./서브_자신감.svg": "b5a6",
	"./서브_주력.svg": "a8ba",
	"./서브_책임감.svg": "f682",
	"./서브_체력.svg": "7f5c",
	"./서브_키.svg": "41dc",
	"./서브_패스킥슛.svg": "91a9",
	"./시야.svg": "caef",
	"./자신감.svg": "8bd0",
	"./주력.svg": "769d",
	"./책임감.svg": "7c47",
	"./체력.svg": "329b",
	"./키.svg": "27af",
	"./패스킥슛.svg": "791d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e54";